import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import LoadingButton from '@mui/lab/LoadingButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { StepContent, StepTagRow, StepTagChip, StepTagLabel, ContinueButtonRow } from '../styled';
import { TermsList, TermsNote, TermsCheckboxRow } from './styled';

type TermsStepProps = {
  accepted: boolean;
  onToggleAccept: () => void;
  onContinue: () => void;
  isChecking: boolean;
};

export default function TermsStep({ accepted, onToggleAccept, onContinue, isChecking }: TermsStepProps) {
  return (
    <StepContent>
      <StepTagRow>
        <StepTagChip>
          <StepTagLabel>1 de 2</StepTagLabel>
        </StepTagChip>
        <StepTagLabel>Termo de aceite</StepTagLabel>
      </StepTagRow>

      <Typography variant="h3">Solicitação de renovação de pedido</Typography>

      <Typography variant="body1R" sx={{ lineHeight: 1.5 }}>
        A revalidação de qualquer prescrição ou pedido de exame é um ato médico que exige responsabilidade técnica e legal.
        Permitimos esta solicitação apenas se:
      </Typography>

      <TermsList>
        <li>A receita e/ou o exame estiverem registrados em seu prontuário da Oya.</li>
        <li>
          Sua última consulta tiver acontecido há, no máximo, 3 meses. Caso esse período tenha sido ultrapassado, será
          necessário agendar uma nova consulta.
        </li>
      </TermsList>

      <Typography variant="body1R" sx={{ lineHeight: 1.5 }}>
        Nossas médicas avaliam e respondem o pedido em até <b>7 dias úteis</b> diretamente no seu e-mail cadastrado.
      </Typography>

      <TermsNote>
        *Nota: O prazo de 3 meses é o limite máximo estendido de segurança pela Oya, em conformidade com as normas do CFM
        para acompanhamento de tratamentos.
      </TermsNote>

      <TermsCheckboxRow onClick={onToggleAccept}>
        <Checkbox checked={accepted} sx={{ color: 'brand.darkGreen' }} />
        <Typography variant="body2R">Li e aceito as condições e prazos médicos.</Typography>
      </TermsCheckboxRow>

      <ContinueButtonRow>
        <LoadingButton
          variant="contained"
          color="primary"
          endIcon={<ArrowForwardIcon />}
          disabled={!accepted}
          loading={isChecking}
          onClick={onContinue}
        >
          Continuar
        </LoadingButton>
      </ContinueButtonRow>
    </StepContent>
  );
}
